module.exports = __webpack_public_path__ + "static/media/notFound.3b9eed64.svg";